




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactStatus from '@/models/Contacts/ContactStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';


@Component({
  name: 'ContactStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: ContactStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case ContactStatus.Active:
				color = "green--text";
				break;
			case ContactStatus.Inactive:
				color = "grey--text";
				break;
			default:
				color = "grey-text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case ContactStatus.Active:
				text = "ACTIVE";
				break;
			case ContactStatus.Inactive:
				text = "INACTIVE";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
